import {BaseClient} from "../../baseclient";
import {WasmExtension} from "../wasm";
import {NftQueryExtension, NftQueryExtensionMethods} from "./query";
import {NftTxExtension, NftTxExtensionMethods} from "./tx";

export type NftExtension = NftQueryExtension & NftTxExtension;
export type NftExtensioMethods = NftQueryExtensionMethods & NftTxExtensionMethods;

export function NftExtension<T extends {new (...args: any[]): BaseClient & NftExtension & WasmExtension}>(constructor: T): T {
  return class extends NftQueryExtension(NftTxExtension(constructor)) {};
}

export * from "./amino";
export * from "./query";
export * from "./tx";
